<script>
import StrapSearchResultHeader from '@phoenix/mixins/components/strap-search/StrapSearchResultHeader';
import StrapSearch from './StrapSearch';

export default {
  components: { StrapSearch },

  mixins: [StrapSearchResultHeader],

  props: {
    id: {
      type: String,
      required: true,
    },
    resultPageHref: {
      type: String,
      required: true,
    },
    contactPageHref: {
      type: String,
      required: true,
    },
    findWatchReferenceModalId: {
      type: String,
      default: '',
    },
  },
};
</script>

<template>
  <div class="page-header__banner">
    <header id="banner-content" class="page-header__content">
      <div class="container md:container--md banner-content">
        <h1 class="banner-content__title scrim">{{ title }}</h1>
      </div>
      <div class="container mt-10">
        <strap-search
          :id="id"
          :result-page-href="resultPageHref"
          :contact-page-href="contactPageHref"
          :find-watch-reference-modal-id="findWatchReferenceModalId"
        ></strap-search>
      </div>
    </header>
  </div>
</template>
